import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetJobOffer } from 'src/app/models/job-offer/get-job-offer';
import { ViewCountBaseService } from 'src/app/services/view-count-base.service';
import { ViewType } from 'src/app/services/view-tracking.service';

@Component({
  selector: 'app-job-offer-card',
  templateUrl: './job-offer-card.component.html',
  styleUrls: ['./job-offer-card.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class JobOfferCardComponent implements OnChanges {
  @Input() offer!: GetJobOffer;

  // Campos mapeados para consistencia en el frontend
  candidatesCount: number = 0;
  interviewCount: number = 0;
  viewCounts: any;

  constructor(private viewCountService: ViewCountBaseService) {
    this.viewCounts = this.viewCountService.createViewCountsSignal();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['offer'] && this.offer) {
      // Usar los campos específicos de GetJobOffer para reclutadores
      this.candidatesCount = this.offer.totalAplicaciones ?? 0;
      this.interviewCount = this.offer.totalEntrevistas ?? 0;

      // Cargar el conteo de visitas usando el servicio
      this.loadViewCount();
    }
  }
  getViewCount(): number {
    return this.viewCountService.getViewCount(this.viewCounts, this.offer.id);
  }

  private loadViewCount(): void {
    if (this.offer?.id) {
      this.viewCountService.loadViewCounts(
        [this.offer],
        ViewType.JobOffer,
        this.viewCounts
      );
    }
  }
}
